var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-link no-underline",attrs:{"to":_vm.localizedRoute(_vm.link)}},[_c('span',{staticClass:"nav-link-text cl-white"},[_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }